


















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { http } from "@/shared/https";
import AuthService from "@/services/auth.service";

const auth = new AuthService();

@Component({
  components: {},
})
export default class UserProfileComponent extends Vue {  
  private Status: string = "";
  private snackColor: string = "";
  private snackBar: boolean = false; 
  languages: any = []; 
  @Prop() Name: string;
  @Prop() Email: string;
  @Prop() PreferredLanguageId: Int32Array;
  isDirty: boolean = false;
  
  mounted() {    
    http.get("/api/common/GetLookUp?fieldname=PreferredLanguage")
      .then((resp: any) => {
        this.languages = resp.data.Record;
      }) 
  } 

  //Submits the change password form after validation
  Submit(): any {
    if ((this.$refs.form1 as Vue & { validate: () => boolean }).validate()) {
      auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          auth.getUser().then((user) => {
            var data = {
              Id: user.profile.sub,              
              preferredLanguageId: this.PreferredLanguageId
            };            

            http.put("/api/Profile/UpdateUserProfile/", data).then((resp: any) => {
              this.snackBar = true;

              if (resp.status >= 200 && resp.status < 300) {                            
                var result = resp.data.Value;                                           

                if (result.Result === "OK") {
                  this.Status = result.Message;
                  this.snackColor = "green";
                  this.isDirty = false;
                } else {
                  this.Status = result.Message;
                  this.snackColor = "red";
                }
              } else {
                this.Status = "Change preferred language operation failed.";
                this.snackColor = "red darken-2";
              }
            });
          });
        }
      });
    }
  } 
}
